import React from 'react';

const OutlinedFilterIcon = ({ width = 16, height = 14, color = '#7F38E9' }, ref) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 14" fill="none" ref={ref}>
      <path
        d="M12.6673 1H3.33398C2.39132 1 1.91998 1 1.62732 1.27467C1.33398 1.54933 1.33398 1.992 1.33398 2.87667V3.33667C1.33398 4.028 1.33398 4.374 1.50732 4.66067C1.68065 4.94733 1.99598 5.126 2.62865 5.482L4.57065 6.57533C4.99465 6.814 5.20732 6.93333 5.35932 7.06533C5.67532 7.33933 5.86998 7.662 5.95798 8.05867C6.00065 8.248 6.00065 8.47067 6.00065 8.91533V10.6953C6.00065 11.3013 6.00065 11.6047 6.16865 11.8407C6.33665 12.0773 6.63532 12.194 7.23132 12.4273C8.48398 12.9167 9.10998 13.1613 9.55532 12.8827C10.0007 12.6047 10.0007 11.968 10.0007 10.6947V8.91467C10.0007 8.47067 10.0007 8.248 10.0433 8.058C10.127 7.66944 10.3379 7.31989 10.6427 7.06467C10.794 6.93333 11.0067 6.814 11.4307 6.57467L13.3727 5.48133C14.0047 5.126 14.3213 4.948 14.494 4.66133C14.6673 4.37467 14.6673 4.028 14.6673 3.336V2.876C14.6673 1.992 14.6673 1.54933 14.374 1.27467C14.082 1 13.6107 1 12.6673 1Z"
        stroke={color}
        strokeWidth="1"
      />
    </svg>
  );
};

export default React.forwardRef(OutlinedFilterIcon);
